import { Box } from '@chakra-ui/react';

export default function VBox({ children, ...props }) {
  return <Box {...props}>{children}</Box>;
}
